var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorreo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "unread_mail",
    "data-name": "unread mail",
    d: "M1276.786,1174h-29.571a3.249,3.249,0,0,0-2.118.789.627.627,0,0,0-.1.068c-.011.01-.015.024-.025.036a3.049,3.049,0,0,0-.967,2.218v21.777a3.168,3.168,0,0,0,3.214,3.112h29.571a3.168,3.168,0,0,0,3.214-3.112v-21.777A3.168,3.168,0,0,0,1276.786,1174Zm-29.571,1.245h29.571a1.974,1.974,0,0,1,.738.143l-15.537,15.039-15.529-15.03A1.967,1.967,0,0,1,1247.214,1175.245Zm-1.929,23.644v-21.777a1.8,1.8,0,0,1,.231-.867l12.025,11.639-12.108,11.719A1.8,1.8,0,0,1,1245.286,1198.889Zm31.5,1.867h-29.571a1.955,1.955,0,0,1-.914-.233l12.15-11.759,2.907,2.814c.011.01.025.013.037.023a.634.634,0,0,0,1.215-.02s0,0,.005,0l2.907-2.814,12.159,11.768A1.957,1.957,0,0,1,1276.786,1200.756Zm1.929-1.867a1.8,1.8,0,0,1-.156.732l-12.127-11.738,12.042-11.656a1.8,1.8,0,0,1,.24.884Z",
    transform: "translate(-1244 -1174)",
    fill: "#235677"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo);
export default __webpack_public_path__ + "static/media/correo.813cb28180b2a11aac119da078303ac5.svg";
export { ForwardRef as ReactComponent };